<template>
  <div id="software">
     <div class="text">
        <p>一、项目概况</p>
        <p>
          以“保基本、强基层、建机制”为指导思想，以“大病不出县、小病不出乡”为业务目标，通过构建以区域中心医院为龙头，覆盖县域内基层医疗卫生机构的医共体信息化支撑体系，提升基层卫生服务机构的服务能力和服务水平。建成标准统一、科学先进、高效实用的全民健康服务体系，实现与深化医改要求相符合的、与居民医疗健康服务需求相适应的、适度超前的医疗健康服务，助力区域医疗卫生服务高质量发展。
        </p>
        <p>二、建设内容</p>
        <p>1、云数据中心机房建设：按照网络安全等保三级要求对区域中心医院新机房建设；按照网络安全等保三级对区域中心医院进行网络安全建设</p>
        <p>2、云HIS建设：部署建设可支撑四级电子病历应用的二级医院云HIS系统，包括15大类117个功能模块，涵盖基础HIS、EMR、LIS、PACS、体检、用血、合理用药、院内感染、手术麻醉、重症监护、血透净化等内容。</p>
        <p>3、搭建“一个数据中心”+“三大应用”，建设满足数据双活、异地灾备和三级安全等级保护要求的区域健康医疗数据中心。并基于数据中心打造三大类应用。</p>
        <p>三、建设方案</p>
         <div class="flex">
          <img
            src="@/assets/images/20250724/ruanjian/yigongti.png"
            style="width: 100%;"
            alt=""
          />
        </div>
        <p>依据国家相关政策文件要求，本项目拟通过“1136”的一体化模式来建设医共体信息平台：即“1个平台”、“1个数据中心”、“3大应用”和“5个中心”，实现医共体成员单位间行政、业务、服务、信息等互联互通，业务协同高效的数字化医疗集团。    </p>
        <p>“一个平台”：构建一个满足互联互通要求的医共体信息平台，以数据交换平台和统一消息总线服务支撑各系统之间互联互通，按照全省统一的数据资源目录，实现县域内患者信息的整合及域外患者信息的归集。在业务层面上，医疗集团信息平台以包括标准数据集、数据元目录及值域代码和疾病、药品、医疗服务项目字典在内的标准规范体系来支撑业务应用协同。向下联接辖区内各级各类医疗卫生机构，向上对接省三医联动一张网平台，横向联接医保、妇幼、疾控、财政等相关部门，形成一个互联互通的集团化医疗卫生业务协作网络。</p>
        <p>“一个数据中心”：以区域中心医院机房为主，医共体成员自有机房为辅建设满足数据双活、异地灾备和三级安全等级保护要求的医共体健康医疗数据中心。构建包括临床数据库、基础数据库、运营数据库、医疗资源库等在内的统一数据资源中心，有效整合医疗、卫生、健康及第三方服务行业的相关数据，实现基础数据的唯一标识和一致性，同时满足医疗集团内各医疗卫生机构的互联互通要求，方便综合管理和决策分析，提高资源利用效率。</p> 
        <p>“三大应用”：基于医疗集团信息平台打造三大类应用，一是业务协同类应用，通过远程影像、远程心电、远程检验、远程病理、远程医疗等应用，实现医疗集团资源高效共享和下沉，实现线上线下诊疗等业务一体化。二是便民惠民类应用，以“一档一卡”为核心现统一身份识别和数据共享，推进网上预约、线上支付、在线随访、健康咨询、慢病管理和检查检验结果在线查询等服务，提高居民自我健康管理能力。三是综合监管类应用，通过采用DRG等大数据分析等工具对健康医疗大数据进行分析应用，实现对医改进展、医疗业务、公共卫生业务、医保业务、卫生资源等的在线监管、运行监测和决策支持，并对医疗集团运行效果进行全面、科学、宏观、精准的分析和评价。</p> 
        <p>“五个中心”：推进远程影像中心、远程检验中心、远程会诊中心、远程病理中心、远程心电中心等五个共享中心建设，按照医疗集团单位组成结构进行区域协同业务划分，实现基层检查、上级诊断以及检验检查结果共享互认，提供各类医疗健康数据的跨机构共享调阅和业务协同。</p>
    
      </div>
  </div>
</template>
<script>
export default {
  name: "software",
  data() {
    return {};
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text{
  line-height: 24px;
  font-weight: 500;
    color: #666;
    margin-top: 30px;
    margin-right: 20px;
   text-indent: 28px
}
</style>




// WEBPACK FOOTER //
// src/view/Solution9.vue